import { AbstractControl, AsyncValidatorFn, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormArrayExtended } from './form-array-extended.class';
import { FormControlExtended } from './form-control-extended.class';
import { FormGroupExtended } from './form-group-extended.class';

// This function is used as wrapper for any another default or custom angular validators
// It makes control valid even if validator has error, and set this error as warning property
export function warning(validator: AsyncValidatorFn): AsyncValidatorFn;
export function warning(validator: ValidatorFn): ValidatorFn;
export function warning(validator: any): any {
  return (control: AbstractControl): ValidationErrors | null => {
    const controlExtended = control as FormGroupExtended | FormArrayExtended | FormControlExtended<string>;
    controlExtended.warnings = null;
    const validatorResult = validator(control);
    const isValidatorAsync = validatorResult instanceof Promise || validatorResult instanceof Observable;
    if (isValidatorAsync) {
      const observable = validatorResult instanceof Promise ? from(validatorResult) : validatorResult;
      return observable.pipe(
        map((value: ValidationErrors | null) => {
          controlExtended.warnings = value;
          return null;
        })
      );
    } else {
      controlExtended.warnings = validatorResult;
      return null;
    }
  };
}
